import { render, staticRenderFns } from "./Test34.vue?vue&type=template&id=521e28ee&scoped=true&"
import script from "./Test34.vue?vue&type=script&lang=js&"
export * from "./Test34.vue?vue&type=script&lang=js&"
import style0 from "@/assets/poliglotiki/main.css?vue&type=style&index=0&lang=css&"
import style1 from "./Test34.vue?vue&type=style&index=1&id=521e28ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521e28ee",
  null
  
)

export default component.exports